import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-6">
    <h2 className="text-lg font-semibold text-blue-800 mb-2">{title}</h2>
    <div className="text-sm leading-relaxed text-gray-700 space-y-2">{children}</div>
  </section>
);

export default function Disclaimer() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-blue-900 mb-4">免責事項</h1>

      <Section title="一般事項">
        <p>
          本アプリ「PachiCalc」は、パチンコの回転率を算出するための参考ツールです。
          提供する情報や計算結果の正確性・完全性については万全を期していますが、その内容を保証するものではありません。
        </p>
      </Section>

      <Section title="利用者の責任">
        <p>
          本アプリの利用により得られた結果や情報は、あくまで参考値としてご利用ください。
          本アプリを利用したことによる投資判断、遊技行動、その他一切の結果について、当方は一切の責任を負いません。
        </p>
      </Section>

      <Section title="損害について">
        <p>
          本アプリの利用または利用できなかったことにより発生した直接的・間接的な損害や不利益について、当方は一切の責任を負いません。
          また、本アプリの提供は予告なく中止・変更される場合があります。
        </p>
      </Section>

      <Section title="保存データについて">
        <p>
          履歴などの保存データ（入力した通常時回転数・出玉・差玉・
          <b>店舗名</b>・<b>機種名</b>{' '}
          など）は、利用者の端末ブラウザ（localStorage）にのみ保存されます。
          当方が取得・収集することはありません。
        </p>
        <p>
          ブラウザの仕様変更、端末の初期化、キャッシュ削除、バージョンアップ等により保存データが消失する可能性があります。
          データが消失した場合であっても、当方は一切の責任を負いません。
        </p>
      </Section>

      <Section title="画像取り込み（OCR）について">
        <p>
          「画像から反映」機能では、出玉の<strong>数字一覧画像</strong>
          を解析して合計値を自動計算します。
          解析はブラウザ上で実行され、画像や認識結果がサーバーへ送信されることはありません。
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <b>精度・限界：</b>{' '}
            画像の解像度・明るさ・傾き・フォント等により誤認識が発生する場合があります。
            出力結果は必ずご自身で確認してください。誤認識に起因する不利益について、当方は責任を負いません。
          </li>
          <li>
            <b>対応範囲：</b> 数字行（例：<code>1200</code> / <code>1,200</code> /{' '}
            <code>500x3</code> / <code>500*3</code>）を前提とします。
            表や記号、背景装飾が多い画像は正しく解析できない場合があります。
          </li>
          <li>
            <b>端末権限：</b>{' '}
            画像選択・撮影のために端末の写真ライブラリ／カメラを利用することがありますが、権限の範囲を超えた取得は行いません。
          </li>
          <li>
            <b>編集・修正：</b>{' '}
            解析結果が不十分な場合は、フォームやモーダルで手動修正・再集計が可能です。
          </li>
        </ul>
      </Section>

      <Section title="PWA・オフライン利用について">
        <p>
          本アプリは PWA（Progressive Web App）として提供され、オフライン環境でも利用可能です。
          ただし、キャッシュの挙動や端末依存の仕様により、最新の情報が反映されない場合や一部ページが利用できない場合があります。
        </p>
        <p>
          また、ブラウザやOSの仕様変更により、PWA機能やオフライン利用が予告なく制限・変更される可能性があります。
          これにより生じた不利益について、当方は一切の責任を負いません。
        </p>
        <p>
          さらに、<b>キャッシュ更新のタイミング</b>
          によっては古いバージョンのまま表示される場合があります。
          その際は更新通知（UpdateBanner）の案内に従うか、ブラウザのキャッシュ削除／ハードリロードを行ってください。
        </p>
      </Section>

      <Section title="著作権・知的財産">
        <p>
          本アプリに含まれるプログラム、デザイン、テキスト、画像などは著作権法その他の知的財産権によって保護されています。
          無断での転載・改変・再配布は禁止されています。
        </p>
      </Section>

      <Section title="改訂">
        <p className="pb-5">
          本免責事項は必要に応じて改訂される場合があります。 改訂後は速やかに本ページ
          <b>および更新履歴（Changelog）</b>に反映いたします。
        </p>
      </Section>
    </div>
  );
}
